module.exports = __webpack_public_path__ + "static/img/oprCt_bg_white_06.28d037d2.svg";